import {OfferType} from "@pg-rp/common-types";

export enum HomeMatchFloorsPreference {
    GROUND = "parter",
    HIGH = "wysokie_pietra",
    LOW = "niskie_pietra",
    TOP = "ostatnie_pietro",
    WITHOUT_GROUND = "bez_parteru",
    WITHOUT_TOP = "bez_ostatniego"
}

export enum HomeMatchFinancingPreference {
    CASH = "gotowka",
    CREDIT = "kredyt",
    UNKNOWN = "nie_wiem"
}

export const HomeMatchPreferencesSurveyPropertyType = {
    FLAT: OfferType.FLAT,
    HOUSE: OfferType.HOUSE
} as const;

export type HomeMatchPreferencesSurveyPropertyType = (typeof HomeMatchPreferencesSurveyPropertyType)[keyof typeof HomeMatchPreferencesSurveyPropertyType];

export enum HomeMatchPreferencesMarketType {
    BOTH = 3,
    PRIMARY = 1,
    SECONDARY = 2
}

export enum HomeMatchPreferencesLocationSearchMethod {
    MANUAL_INPUT = "manual_input",
    POPULAR_SEARCH_CLICK = "popular_search_click"
}

export enum HomeMatchPreferencesSurveyBuildingHeight {
    HIGH = "high",
    LOW = "low"
}
import {OfferType} from "@pg-rp/common-types";

export enum HomeMatchFloorsPreference {
    GROUND = "parter",
    HIGH = "wysokie_pietra",
    LOW = "niskie_pietra",
    TOP = "ostatnie_pietro",
    WITHOUT_GROUND = "bez_parteru",
    WITHOUT_TOP = "bez_ostatniego"
}

export enum HomeMatchFinancingPreference {
    CASH = "gotowka",
    CREDIT = "kredyt",
    UNKNOWN = "nie_wiem"
}

export const HomeMatchPreferencesSurveyPropertyType = {
    FLAT: OfferType.FLAT,
    HOUSE: OfferType.HOUSE
} as const;

export type HomeMatchPreferencesSurveyPropertyType = (typeof HomeMatchPreferencesSurveyPropertyType)[keyof typeof HomeMatchPreferencesSurveyPropertyType];

export enum HomeMatchPreferencesMarketType {
    BOTH = 3,
    PRIMARY = 1,
    SECONDARY = 2
}

export enum HomeMatchPreferencesLocationSearchMethod {
    MANUAL_INPUT = "manual_input",
    POPULAR_SEARCH_CLICK = "popular_search_click"
}

export enum HomeMatchPreferencesSurveyBuildingHeight {
    HIGH = "high",
    LOW = "low"
}
